<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="vouchers"
            :description="false"
            search
            @selected="handleSelected"
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.ManageMessage") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Message Template' })"
                  size="small"
                  >{{ $t("setup.label.AddMessage") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.TemplateDescription") }}</vs-th>
              <vs-th>{{ $t("setup.label.Subject") }}</vs-th>
              <vs-th>{{ $t("setup.label.MessageType") }}</vs-th>
              <vs-th>{{ $t("setup.label.Header") }}</vs-th>
              <vs-th>{{ $t("setup.label.Body") }}</vs-th>
              <vs-th>{{ $t("setup.label.Footer") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="vouchers"
                v-for="(vouchers, index) in data"
              >
                <vs-td :data="vouchers.templateDescription">{{
                  vouchers.templateDescription
                }}</vs-td>
                <vs-td :data="vouchers.subject">{{ vouchers.subject }}</vs-td>
                <vs-td :data="vouchers.messageType">{{
                  vouchers.messageType
                }}</vs-td>
                <vs-td :data="vouchers.header">{{ vouchers.header }}</vs-td>
                <vs-td :data="vouchers.body">{{ vouchers.body }}</vs-td>
                <vs-td :data="vouchers.footer">{{ vouchers.footer }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('system.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editMessageTemplate(vouchers.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('system.label.Delete')"
                      class="icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor text-danger"
                      @click.stop="
                        conditionId = vouchers.id;
                        deleteMassageTemPopup = true;
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteMassageTemPopup"
      :title="$t('setup.label.ManageMessage')"
      @deletePressed="deleteMassageTemplate(conditionId)"
      @cancelPressed="deleteMassageTemPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      voucher: [],
      deleteMassageTemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      vouchers: (state) => state.messageTemplate.ListMessages,
    }),
  },
  methods: {
    async getMessages() {
      this.loading = true;
      await this.$store.dispatch("messageTemplate/setMessages");
      this.voucher = this.vouchers;
      this.loading = false;
    },
    async deleteMassageTemplate(id) {
      try {
        await this.$store.dispatch("messageTemplate/deletemessagesAction", id);
        this.deleteMassageTemPopup = false;
        this.getMessages();
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Manage Message Successfully Deleted!!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Failed",
          icon: "warning",
          text: e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          ),
          type: "warning",
        });
      }
    },
    handleSelected(vouchers) {
      this.$router.push({
        name: "View Message Template",
        params: { id: vouchers.id },
      });
    },
    editMessageTemplate(id) {
      this.$router.push({ name: "Edit Message Template", params: { id: id } });
    },
  },
  mounted() {
    this.getMessages();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
